module.exports = __webpack_public_path__ + "static/media/production3.db4cb4ba.jpg";